import createReducer from '../utils/createReducer';
import actions from '../actions/reviewsActions';
import ReviewsRecord from '../records/reviewsRecord';

const initialState = new ReviewsRecord();

const actionHandlers = {
    [actions.FETCH_REVIEWS_SUCCESS](state, {payload}) {
        const {reviews: newReviews, isFetching} = payload;
        const {reviews: prevReviews} = state;

        // Merge the reviews but skip any that already exist in store
        const prevReviewsUuids = prevReviews.map((prevReview) => prevReview.uuid);
        const mergedReviews = [...prevReviews];

        newReviews.forEach((newReview) => {
            const incomingUuid = newReview.uuid;
            if (prevReviewsUuids.indexOf(incomingUuid) === -1) {
                mergedReviews.push(newReview);
            }
        });

        return state.merge({isFetching}).mergeIn(['reviews'], mergedReviews);
    },
    [actions.FETCH_REVIEWS_REQUEST_STARTED](state, {payload}) {
        const {isFetching} = payload;

        return state.merge({isFetching});
    },
    [actions.FETCH_REVIEWS_FAILURE](state, {payload}) {
        const {isFetching} = payload;

        return state.merge({isFetching});
    },
    [actions.EXPAND_REVIEW_CLICKED](state, {payload}) {
        const {reviewId} = payload;

        return state.merge({reviewId});
    },
    [actions.SCROLL_REVIEWS_TOP](state, {payload}) {
        const {scrollTop} = payload;
        return state.merge({scrollTop});
    },
    [actions.SET_PAGE_INDEX](state, {payload}) {
        const {pageIndex} = payload;
        return state.merge({pageIndex});
    },
    [actions.NEXT_PAGE](state) {
        const {pageIndex} = state;
        return state.merge({pageIndex: pageIndex + 1, prevPageIndex: pageIndex});
    },
    [actions.PREV_PAGE](state) {
        const {pageIndex} = state;

        return state.merge({
            pageIndex: pageIndex > 1 ? pageIndex - 1 : pageIndex,
            prevPageIndex: pageIndex
        });
    },
    [actions.REPORT_REVIEW_CLICKED](state, {payload}) {
        const {reviewId} = payload;

        const updatedReviews = state.reviews.map((review) => {
            if (review.uuid === reviewId) {
                return {...review, isReportReviewActive: false};
            }
            return review;
        });

        return state.mergeIn(['reviews'], updatedReviews);
    }
};

export default createReducer(actionHandlers, initialState);
